export default {
  username: 'users.username',
  password: 'users.password',
  roles: 'users.roles',
  partnerCode: 'users.partnerCode',
  createUser: 'users.createUser',
  listOfUsers: 'users.listOfUsers',
};
